import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=6ed58106&scoped=true"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"
import style0 from "./Icon.vue?vue&type=style&index=0&id=6ed58106&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed58106",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ed58106')) {
      api.createRecord('6ed58106', component.options)
    } else {
      api.reload('6ed58106', component.options)
    }
    module.hot.accept("./Icon.vue?vue&type=template&id=6ed58106&scoped=true", function () {
      api.rerender('6ed58106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/Icon.vue"
export default component.exports